import React from 'react'
import { Link } from 'react-router-dom'

function Daissyice() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">Daisy</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/daisyice.png" alt="Daisy" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Daisy</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Attractive ice cream presentation and easy service.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">DAISY is the ideal ice cream counters solution, perfect for equipping small and medium-sized shops. Available in various sizes and options, it offers flexibility and design so that your ice creams are presented attractively and efficiently!.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Ice cream <span className=' text-blue-400'>-18… -15 °C  </span> (4L1)<span className=' text-blue-400'> -18… -10 °C</span>(4G3)</p>

    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">  R290</p>
         </div>

         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Amazing ice creams and popsicles with a perfect presentation!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>pecialised model for displaying and serving ice cream with smooth ventilation for even temperature distribution throughout the display, ensuring that ice cream is properly preserved up to 8 cm above the pan.</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Climate class 4, two temperature classes:
    L1 (-18... -15 °C) and G3 (-18... -10 °C).</div>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Models with capacity for 12, 18, 24, 5L ice cream pans.</div>
    </div>
     {/* ✅ Image Wrapper */}
     <div className="w-full md:w-1/2">
                 <img src="/images/daisyicecase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/daisyicecard.jpg",
      text: "Ice cream counters with integrated condensing unit (plug-in).",
    },
    {
      img: "images/daisyicecard1.jpg",
      text: "Double-glazed end side panels and passive anti-condensation system for greater energy savings.",
    },
    {
      img: "images/daisyicecard2.jpg",
      text: "Front glass with gas struts for easy access and cleaning of the display unit.",
    },
    {
      img: "images/daisyicecard3.jpg",
      text: "Easy access to the condenser for cleaning and maintenance.",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6 md:mt-20">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


     </div>
    
  
        </div>
      )
    }

export default Daissyice